import React from 'react';
import { Breadcrumbs, Link, ModuleBase, ResponsiveImage, SocialImage } from '@/components';
import { useTranslations } from 'next-intl';
import { ExpertElementModel } from './ExpertElement';

const ExpertElementApp = (data: ExpertElementModel) => {
  const { breadcrumb, name, jobTitle, shortBio, socialMedia, image } = data.props;

  const t = useTranslations();

  return (
    <ModuleBase data={data} noPadding className="relative overflow-hidden">
      <div className="top-0 right-0 h-full w-full overflow-hidden md:absolute md:w-1/2 lg:w-5/12 xl:w-4/12">
        {image && (
          <ResponsiveImage
            image={image}
            widths={{ xs: 600, sm: 456, md: 512, lg: 611, xl: 611, xxl: 700 }}
            heights={{ xs: 600, sm: 684, md: 769, lg: 918, xl: 918, xxl: 1000 }}
          />
        )}
      </div>

      <div className="container pt-7 pb-[90px] sm:pt-20 md:pt-7 xl:min-h-[905px] xl:pb-[200px]">
        <div className="flec-col flex w-full flex-col md:w-6/12 md:pr-4 lg:w-7/12 lg:pr-10 xl:w-8/12">
          {breadcrumb && <Breadcrumbs data={breadcrumb} />}
          {name && (
            <h1 className="pt-2 text-[35px] leading-10 font-light sm:text-[35px] sm:leading-10 md:pt-15 xl:text-[70px] xl:leading-[74px]">
              {name}
            </h1>
          )}
          {jobTitle && <p className="body-1 pt-15 sm:pt-10">{jobTitle}</p>}
          {shortBio && (
            <div className="py-10 text-base leading-[22px] font-light" dangerouslySetInnerHTML={{ __html: shortBio }} />
          )}
          {socialMedia && (
            <div className="mt-6 flex gap-5 lg:mt-13">
              {socialMedia.map((media, index) => (
                <Link key={index} link={media.link} className="btn secondary flex items-center !px-5">
                  <SocialImage type={media.socialPlatform} className="filter-black !mr-0 h-5 w-5" />
                  <div className="mx-2 h-full w-px bg-black/20" />
                  <span className="tracking-[0.1px] underline">{t('general.$viewprofile')}</span>
                </Link>
              ))}
            </div>
          )}
        </div>
      </div>
    </ModuleBase>
  );
};

export default ExpertElementApp;
